import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { isMyAccountPath } from '@/cms/routes/myAccountPaths'
import { useConfiguration } from '../../infrastructure/config/ConfigProvider'
import { DismissibleBanner } from './DismissibleBanner'
import styles from './EmergencyBanner.module.css'

function shouldShowForPublicationCode(allowedCodes: string | undefined, publicationCode: string): boolean {
  if (publicationCode === 'NONE')
    return true
  if (!allowedCodes)
    return true
  return allowedCodes.split(',').map(code => code.trim()).includes(publicationCode)
}

export function EmergencyBanner() {
  const emergencyText = process.env.NEXT_PUBLIC_EMERGENCY_BANNER_TEXT
  const emergencySupportingText = process.env.NEXT_PUBLIC_EMERGENCY_BANNER_SUPPORTING_TEXT
  const emergencyAllowedCodes = process.env.NEXT_PUBLIC_EMERGENCY_BANNER_PUBLICATION_CODES

  const mySunwebText = process.env.NEXT_PUBLIC_MY_SUNWEB_BANNER_TEXT
  const mySunwebSupportingText = process.env.NEXT_PUBLIC_MY_SUNWEB_BANNER_SUPPORTING_TEXT

  const { asPath } = useRouter()
  const publicationCode = useConfiguration('publicationCode')
  const intl = useIntl()

  const showEmergency = !!(emergencyText && emergencySupportingText && shouldShowForPublicationCode(emergencyAllowedCodes, publicationCode))
  const showMySunweb = !!(isMyAccountPath(asPath) && mySunwebText)

  if (!showEmergency && !showMySunweb)
    return null

  return (
    <div className={styles.bannerStack}>
      {showMySunweb && (
        <DismissibleBanner
          text={mySunwebText!}
          supportingText={mySunwebSupportingText}
          cookieName="my_sunweb_banner_hash"
          dismissAriaLabel={intl.formatMessage({ id: 'my_portal_banner_dismiss_aria_label' })}
        />
      )}
      {showEmergency && (
        <DismissibleBanner
          text={emergencyText!}
          supportingText={emergencySupportingText}
          cookieName="emergency_banner_hash"
          dismissAriaLabel={intl.formatMessage({ id: 'emergency_banner_dismiss_aria_label' })}
        />
      )}
    </div>
  )
}
